module.exports = __webpack_public_path__ + "23cf8b61aae43e1e82346090012b3e96.webp";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/orks-vignette-preview-420.webp
// module id = 493
// module chunks = 0